
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _403e53jXqI3Tj16JtUBelLvU1Gct6KXQd5dBMg_45Yu3GDKwMeta } from "/vercel/path0/pages/403.vue?macro=true";
import { default as _42926hvTSC3orEAYG6g7kjOIiX3GEcIvv4CUZbcG3mf7ssMeta } from "/vercel/path0/pages/429.vue?macro=true";
import { default as errorN_45ENTyPlpzPg6hn_0BxpsMhhH7pcBYCZkt9W5qJyQFYMeta } from "/vercel/path0/pages/error.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as legalk0TLVEiHS0rRZk_45dGgxPMSO_sTIlOdzIF2DYnz4vk24Meta } from "/vercel/path0/pages/legal.vue?macro=true";
import { default as confirmhy9DGa3G0xlIdbC4mTG_450u3_j0SR_45PjDFjuDBxIs15UMeta } from "/vercel/path0/pages/confirm.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as kariyerKpwCYdgOl0kcEeTLf_45Qh82GFdAk2XVx4s9JXpZRtZjsMeta } from "/vercel/path0/pages/kariyer.vue?macro=true";
import { default as _91_46_46_46alll_93trmCb0cL0I3FfJzKb_XqRlfxQ2HR4aE57oTdG8mQ5FYMeta } from "/vercel/path0/pages/[...alll].vue?macro=true";
import { default as index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as indexuTDYn3DztCG5Pi_45obmWqI4yPu91kwBrh64R9eobIPlsMeta } from "/vercel/path0/pages/block/index.vue?macro=true";
import { default as cookie_45policyXq_8Z0Flba748deoRdQ0oMVSHcZLV_jcLf_uNOOBZ_45oMeta } from "/vercel/path0/pages/cookie-policy.vue?macro=true";
import { default as failedA0aRfbAoyoMz9SwKLVzk9jJvTjLiWMiuisj09kWDnCoMeta } from "/vercel/path0/pages/payment/failed.vue?macro=true";
import { default as privacy_45policy4XTtqETNZShW4bt4tv1KYsHRfQDwaNm0MGXT0dxQJr0Meta } from "/vercel/path0/pages/privacy-policy.vue?macro=true";
import { default as purchase_45terms7cTf7lDrz_ERSxW1G7gJin_45HOX_ICUBT3GbZvUyJfGIMeta } from "/vercel/path0/pages/purchase-terms.vue?macro=true";
import { default as indexcgj1YhTOlUth3jdoUCCx0gwsOKYltazOce0k7q7mnxcMeta } from "/vercel/path0/pages/dashboard/index.vue?macro=true";
import { default as successKA_45rHDuo9AQGaydudQSbqYiGcrOcEqp91DTFaaV9o_QMeta } from "/vercel/path0/pages/payment/success.vue?macro=true";
import { default as _91id_933oSv9NzF80q1efilEyPtNP2KCEmdxh9uZWvOKFMBe1MMeta } from "/vercel/path0/pages/admin/blogs/[id].vue?macro=true";
import { default as indexQUfwHxn7VayTi2_HJBJ_iADwpwObokYXQKLBlVjElfkMeta } from "/vercel/path0/pages/block/[id]/index.vue?macro=true";
import { default as indexrTrdGOGC0T4Cd4PQfy6dLy04Z_45TMRABlLT_45WNwDLE4QMeta } from "/vercel/path0/pages/daily-blog/index.vue?macro=true";
import { default as index_453FZo5jgRmZ6Y9uVf85WK4pnSPqpiqBIWtxG46AIq9wMeta } from "/vercel/path0/pages/admin/blogs/index.vue?macro=true";
import { default as index7snL9UJ5WLMMYu9u6IIh5rvPHrHKNA_tpciPwCSJ9OEMeta } from "/vercel/path0/pages/admin/users/index.vue?macro=true";
import { default as paymentmLy_5dDIh4xrELDvjRdu4G_45kRSAsdTP6L7xteP7W4wAMeta } from "/vercel/path0/pages/dashboard/payment.vue?macro=true";
import { default as profilegWwgBZYKQGsImGBhu__45zWhZU5lo6jkm_NjZ1eH7aevAMeta } from "/vercel/path0/pages/dashboard/profile.vue?macro=true";
import { default as onetoonex8KTFz6_8UolZ5JzvtogJiN2WAX4gkgqEwBr_KqBUh8Meta } from "/vercel/path0/pages/training/onetoone.vue?macro=true";
import { default as indexMuKM0loMVfq3aiP5KOhd7lkLBmSreLisV8ra3f4nHBMMeta } from "/vercel/path0/pages/admin/blocks/index.vue?macro=true";
import { default as createxF8DA9OtxJ7MQRfa68bJkoKX1VAhmeBNjUgxiqm9lnIMeta } from "/vercel/path0/pages/admin/blogs/create.vue?macro=true";
import { default as indexBoP_454NlrdE_Y6I_45BQpV9fALyNUWIcmG3AODdJF45f7EMeta } from "/vercel/path0/pages/admin/moduls/index.vue?macro=true";
import { default as indexTVl3fTkMjq3mktEsb3ScbrLqX1glcb_45XobunZTcyr_45sMeta } from "/vercel/path0/pages/subscription/index.vue?macro=true";
import { default as indexih_45KiVdSFfyW_45AbVeah0AQeB7YbUem8VY0ej51sA03sMeta } from "/vercel/path0/pages/admin/contacts/index.vue?macro=true";
import { default as paymentBTCYoTfpy4RqcF22gg_45UEvOnPDCaOvgdHSy__45IISl9kMeta } from "/vercel/path0/pages/subscription/payment.vue?macro=true";
import { default as indexHp5P0v3ItL9r_45M7v8FT1nEIALpNLxShlCkIpE7Sh4GMMeta } from "/vercel/path0/pages/daily-blog/[id]/index.vue?macro=true";
import { default as index_hV8S9PPBX0lzJs7qYxBOD5yETqGbU_Oqlr1w1bpOU4Meta } from "/vercel/path0/pages/admin/serverlogs/index.vue?macro=true";
import { default as subscriptionh2AwgpyJONp1EIn_45TGixuV7RP4OoUvywnffwdrpQM98Meta } from "/vercel/path0/pages/dashboard/subscription.vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    meta: _403e53jXqI3Tj16JtUBelLvU1Gct6KXQd5dBMg_45Yu3GDKwMeta || {},
    component: () => import("/vercel/path0/pages/403.vue")
  },
  {
    name: "429",
    path: "/429",
    component: () => import("/vercel/path0/pages/429.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: errorN_45ENTyPlpzPg6hn_0BxpsMhhH7pcBYCZkt9W5qJyQFYMeta || {},
    component: () => import("/vercel/path0/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    meta: legalk0TLVEiHS0rRZk_45dGgxPMSO_sTIlOdzIF2DYnz4vk24Meta || {},
    component: () => import("/vercel/path0/pages/legal.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/vercel/path0/pages/confirm.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "kariyer",
    path: "/kariyer",
    meta: kariyerKpwCYdgOl0kcEeTLf_45Qh82GFdAk2XVx4s9JXpZRtZjsMeta || {},
    component: () => import("/vercel/path0/pages/kariyer.vue")
  },
  {
    name: "alll",
    path: "/:alll(.*)*",
    meta: _91_46_46_46alll_93trmCb0cL0I3FfJzKb_XqRlfxQ2HR4aE57oTdG8mQ5FYMeta || {},
    component: () => import("/vercel/path0/pages/[...alll].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/admin/index.vue")
  },
  {
    name: "block",
    path: "/block",
    component: () => import("/vercel/path0/pages/block/index.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    meta: cookie_45policyXq_8Z0Flba748deoRdQ0oMVSHcZLV_jcLf_uNOOBZ_45oMeta || {},
    component: () => import("/vercel/path0/pages/cookie-policy.vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/vercel/path0/pages/payment/failed.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policy4XTtqETNZShW4bt4tv1KYsHRfQDwaNm0MGXT0dxQJr0Meta || {},
    component: () => import("/vercel/path0/pages/privacy-policy.vue")
  },
  {
    name: "purchase-terms",
    path: "/purchase-terms",
    meta: purchase_45terms7cTf7lDrz_ERSxW1G7gJin_45HOX_ICUBT3GbZvUyJfGIMeta || {},
    component: () => import("/vercel/path0/pages/purchase-terms.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexcgj1YhTOlUth3jdoUCCx0gwsOKYltazOce0k7q7mnxcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/dashboard/index.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/vercel/path0/pages/payment/success.vue")
  },
  {
    name: "admin-blogs-id",
    path: "/admin/blogs/:id()",
    meta: { ...(_91id_933oSv9NzF80q1efilEyPtNP2KCEmdxh9uZWvOKFMBe1MMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/admin/blogs/[id].vue")
  },
  {
    name: "block-id",
    path: "/block/:id()",
    component: () => import("/vercel/path0/pages/block/[id]/index.vue")
  },
  {
    name: "daily-blog",
    path: "/daily-blog",
    component: () => import("/vercel/path0/pages/daily-blog/index.vue")
  },
  {
    name: "admin-blogs",
    path: "/admin/blogs",
    meta: { ...(index_453FZo5jgRmZ6Y9uVf85WK4pnSPqpiqBIWtxG46AIq9wMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/admin/blogs/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(index7snL9UJ5WLMMYu9u6IIh5rvPHrHKNA_tpciPwCSJ9OEMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/admin/users/index.vue")
  },
  {
    name: "dashboard-payment",
    path: "/dashboard/payment",
    meta: { ...(paymentmLy_5dDIh4xrELDvjRdu4G_45kRSAsdTP6L7xteP7W4wAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/dashboard/payment.vue")
  },
  {
    name: "dashboard-profile",
    path: "/dashboard/profile",
    meta: { ...(profilegWwgBZYKQGsImGBhu__45zWhZU5lo6jkm_NjZ1eH7aevAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/dashboard/profile.vue")
  },
  {
    name: "training-onetoone",
    path: "/training/onetoone",
    component: () => import("/vercel/path0/pages/training/onetoone.vue")
  },
  {
    name: "admin-blocks",
    path: "/admin/blocks",
    meta: { ...(indexMuKM0loMVfq3aiP5KOhd7lkLBmSreLisV8ra3f4nHBMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/admin/blocks/index.vue")
  },
  {
    name: "admin-blogs-create",
    path: "/admin/blogs/create",
    component: () => import("/vercel/path0/pages/admin/blogs/create.vue")
  },
  {
    name: "admin-moduls",
    path: "/admin/moduls",
    meta: { ...(indexBoP_454NlrdE_Y6I_45BQpV9fALyNUWIcmG3AODdJF45f7EMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/admin/moduls/index.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: indexTVl3fTkMjq3mktEsb3ScbrLqX1glcb_45XobunZTcyr_45sMeta || {},
    component: () => import("/vercel/path0/pages/subscription/index.vue")
  },
  {
    name: "admin-contacts",
    path: "/admin/contacts",
    meta: { ...(indexih_45KiVdSFfyW_45AbVeah0AQeB7YbUem8VY0ej51sA03sMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/admin/contacts/index.vue")
  },
  {
    name: "subscription-payment",
    path: "/subscription/payment",
    meta: paymentBTCYoTfpy4RqcF22gg_45UEvOnPDCaOvgdHSy__45IISl9kMeta || {},
    component: () => import("/vercel/path0/pages/subscription/payment.vue")
  },
  {
    name: "daily-blog-id",
    path: "/daily-blog/:id()",
    component: () => import("/vercel/path0/pages/daily-blog/[id]/index.vue")
  },
  {
    name: "admin-serverlogs",
    path: "/admin/serverlogs",
    meta: { ...(index_hV8S9PPBX0lzJs7qYxBOD5yETqGbU_Oqlr1w1bpOU4Meta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/admin/serverlogs/index.vue")
  },
  {
    name: "dashboard-subscription",
    path: "/dashboard/subscription",
    meta: { ...(subscriptionh2AwgpyJONp1EIn_45TGixuV7RP4OoUvywnffwdrpQM98Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/dashboard/subscription.vue")
  }
]